import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Páginas Utilitárias
import ErrorPage from './pages/ErrorPage/ErrorPage';
import HomePage from './pages/HomePage/HomePage';
import HelpPage from './pages/HelpPage/HelpPage';

// Páginas Usuário
import LoginPage from './pages/LoginPage/LoginPage';
import UsersPage from './pages/UsersPage/UsersPage';
import UserFormPage from './pages/UserFormPage/UserFormPage';
import RecuperarSenhaUsuarioPage from './pages/LoginPage/RecuperarSenhaUsuarioPage';
import RecuperarSenhaUsuarioCodigoPage from './pages/LoginPage/RecuperarSenhaUsuarioCodigoPage';

// Páginas Empresa
import EmpresasPage from './pages/EmpresasPage/EmpresasPage';
import EmpresaFormPage from './pages/EmpresaFormPage/EmpresaFormPage';

// Páginas Turma
import TurmasPage from './pages/TurmasPage/TurmasPage';
import TurmaFormPage from './pages/TurmaFormPage/TurmaFormPage';

// Páginas Participante
import ParticipantesPage from './pages/ParticipantesPage/ParticipantesPage';
import ParticipanteFormPage from './pages/ParticipanteFormPage/ParticipanteFormPage';
import ParticipantesAllPage from './pages/ParticipantesAllPage/ParticipantesAllPage';
import ParticipanteEditPage from './pages/ParticipanteEditPage/ParticipanteEditPage';
import LoginParticipantePage from './pages/LoginParticipantePage/LoginParticipantePage';
import LoginParticipanteSenhaPage from './pages/LoginParticipantePage/LoginParticipanteSenhaPage';
import ParticipanteCadastroPage from './pages/ParticipanteCadastroPage/ParticipanteCadastroPage';
import ParticipanteHomePage from './pages/ParticipanteHomePage/ParticipanteHomePage';
import ParticipanteTestDataPage from './pages/ParticipanteTestDataPage/ParticipanteTestDataPage';
import ParticipanteDataPage from './pages/ParticipanteDataPage/ParticipanteDataPage';
import RecuperarSenhaPage from './pages/LoginParticipantePage/RecuperarSenhaPage';
import RecuperarSenhaCodigoPage from './pages/LoginParticipantePage/RecuperarSenhaCodigoPage';

// Páginas Produto
import ProdutosPage from './pages/ProdutosPage/ProdutosPage';
import ProdutoFormPage from './pages/ProdutoFormPage/ProdutoFormPage'

// Páginas Teste
import TestesPage from './pages/TestesPage/TestesPage';
import TesteFormPage from './pages/TesteFormPage/TesteFormPage';
import ResponderTestePage from './pages/ResponderPage/ResponderTestePage';

// Páginas Algoritmos
import AlgoritmosTestePage from './pages/AlgoritmosTestePage/AlgoritmosTestePage';
import ScoringSpecFormPage from './pages/ScoringSpecFormPage/ScoringSpecFormPage';

// Páginas Devolutivas
import AssetsPage from './pages/AssetsPage/AssetsPage';
import AssetsFormPage from './pages/AssetsFormPage/AssetsFormPage';

// Páginas Gerador PDF
import PDFGeneratorPage from './pages/PDFGeneratorPage/PDFGeneratorPage';

// Páginas Vídeo
import VideosPage from './pages/VideosPage/VideosPage';
import VideoFormPage from './pages/VideoFormPage/VideoFormPage';

// Páginas Institucional
import InstitucionalPage from './pages/InstitucionalPage/InstitucionalPage';
import InstitucionalFormPage from './pages/InstitucionalFormPage/InstitucionalFormPage';

// Páginas Trilha
import TrilhasPage from './pages/TrilhasPage/TrilhasPage';
import TrilhaFormPage from './pages/TrilhaFormPage/TrilhaFormPage';

import EadTrilhaPage from './pages/EadTrilhaPage/EadTrilhaPage';

// Componentes
import Navbar from './components/Navbar/Navbar';
import Sidebar from './components/Sidebar/Sidebar';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import ProtectedParticipanteRoute from './components/ProtectedRoute/ProtectedParticipanteRoute';

// Contextos
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { LoaderProvider } from './contexts/LoaderContext';
import { ModalProvider } from './contexts/ModalContext';
import { SessionTimerProvider } from './contexts/SessionTimerContext';

// Estilos
import './App.css';

function AppLayout() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  const showSidebar =
    isAuthenticated &&
    location.pathname !== '/' &&
    !location.pathname.startsWith('/res') &&
    !location.pathname.startsWith('/participante') &&
    !location.pathname.startsWith('/ead');

  return (
    <div className="App">
      <Navbar />

      <Sidebar />

      <main className={`App-content ${showSidebar ? 'App-content--withSidebar' : ''}`}>
        <Routes>

          <Route path="/" element={<LoginPage />} />

          <Route path="/recuperar" element={<RecuperarSenhaUsuarioPage />} />

          <Route path="/recUsu" element={<RecuperarSenhaUsuarioCodigoPage />} />

          <Route path="/*" element={<ErrorPage />} />

          <Route path="/participante/login" element={<LoginParticipantePage />}/>

          <Route path="/participante/senha" element={<LoginParticipanteSenhaPage />}/>

          <Route path="/participante/cadastro" element={<ParticipanteCadastroPage />}/>

          <Route path="/participante/recuperar" element={<RecuperarSenhaPage />}/>

          <Route path="/recSenha" element={<RecuperarSenhaCodigoPage />}/>

          <Route
            path="/ajuda"
            element={
              <ProtectedRoute>
                <HelpPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/res/:idTurma"
            element={
              <ProtectedParticipanteRoute>
                <ResponderTestePage />
              </ProtectedParticipanteRoute>
            }
          />

          <Route
            path="/participante/page"
            element={
              <ProtectedParticipanteRoute>
                <ParticipanteHomePage />
              </ProtectedParticipanteRoute>
            }
          />

          <Route
            path="/participante/page/resultado/:idResultado"
            element={
              <ProtectedParticipanteRoute>
                <ParticipanteTestDataPage />
              </ProtectedParticipanteRoute>
            }
          />

          <Route
            path="/empresas/:idEmpresa/:idTurma/:idParticipante/respostas"
            element={
              <ProtectedRoute>
                <ParticipanteDataPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/usuarios"
            element={
              <ProtectedRoute>
                <UsersPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/usuarios/adicionarUsuario"
            element={
              <ProtectedRoute>
                <UserFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/usuarios/atualizar/:idUsuario"
            element={
              <ProtectedRoute>
                <UserFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/participantes"
            element={
              <ProtectedRoute>
                <ParticipantesAllPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/participantes/atualizar/:idParticipante"
            element={
              <ProtectedRoute>
                <ParticipanteEditPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/empresas"
            element={
              <ProtectedRoute>
                <EmpresasPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/empresas/adicionarEmpresa"
            element={
              <ProtectedRoute>
                <EmpresaFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/empresas/atualizar/:idEmpresa"
            element={
              <ProtectedRoute>
                <EmpresaFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/empresas/:idEmpresa"
            element={
              <ProtectedRoute>
                <TurmasPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/empresas/:idEmpresa/adicionarTurma"
            element={
              <ProtectedRoute>
                <TurmaFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/empresas/:idEmpresa/atualizar/:idTurma"
            element={
              <ProtectedRoute>
                <TurmaFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/empresas/:idEmpresa/:idTurma"
            element={
              <ProtectedRoute>
                <ParticipantesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/empresas/:idEmpresa/:idTurma/adicionarParticipante"
            element={
              <ProtectedRoute>
                <ParticipanteFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/empresas/:idEmpresa/:idTurma/atualizar/:idParticipante"
            element={
              <ProtectedRoute>
                <ParticipanteFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/testes"
            element={
              <ProtectedRoute>
                <TestesPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/testes/adicionarTeste"
            element={
              <ProtectedRoute>
                <TesteFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/testes/atualizar/:idTeste"
            element={
              <ProtectedRoute>
                <TesteFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/algoritmos"
            element={
              <ProtectedRoute>
                <AlgoritmosTestePage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/algoritmos/:idTeste/adicionarAlgoritmo"
            element={
              <ProtectedRoute>
                <ScoringSpecFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/algoritmos/:idTeste/atualizar/:idAlgoritmo"
            element={
              <ProtectedRoute>
                <ScoringSpecFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/devolutivas"
            element={
              <ProtectedRoute>
                <AssetsPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/devolutivas/:idTeste/adicionarDevolutivas"
            element={
              <ProtectedRoute>
                <AssetsFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/devolutivas/:idTeste/atualizar"
            element={
              <ProtectedRoute>
                <AssetsFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/produtos"
            element={
              <ProtectedRoute>
                <ProdutosPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/produtos/adicionarProduto"
            element={
              <ProtectedRoute>
                <ProdutoFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/produtos/atualizar/:idProduto"
            element={
              <ProtectedRoute>
                <ProdutoFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/pdfgenerator"
            element={
              <ProtectedRoute>
                <PDFGeneratorPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/videos"
            element={
              <ProtectedRoute>
                <VideosPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/videos/adicionarVideo"
            element={
              <ProtectedRoute>
                <VideoFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/videos/atualizar/:idVideo"
            element={
              <ProtectedRoute>
                <VideoFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/institucional"
            element={
              <ProtectedRoute>
                <InstitucionalPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/institucional/atualizar/:tipo"
            element={
              <ProtectedRoute>
                <InstitucionalFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/trilhas"
            element={
              <ProtectedRoute>
                <TrilhasPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/trilhas/adicionarTrilha"
            element={
              <ProtectedRoute>
                <TrilhaFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/trilhas/atualizar/:idTrilha"
            element={
              <ProtectedRoute>
                <TrilhaFormPage />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ead/:idTurma"
            element={
              <ProtectedParticipanteRoute>
                <EadTrilhaPage />
              </ProtectedParticipanteRoute>
            }
          />

        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
        <SessionTimerProvider warnBelowPercent={20} warnBelowSeconds={300} tickMs={1000}>
          <LoaderProvider>
            <ToastProvider>

              <Router>
                <AppLayout />

              </Router>
            </ToastProvider>
          </LoaderProvider>
        </SessionTimerProvider>
      </ModalProvider>
    </AuthProvider>
  );
}

export default App;
